module.exports = __webpack_public_path__ + "img/3P_LOGO_Reversed-big.e7902366.png";